import { IOrderBasis } from '@/coreDomainsModule/entities/orderBasis';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IOrderBasisRepository } from '@/coreInfrastructureModule/interfaces/IOrderBasisRepository';
import { OrderBasisAdapter } from '../adapters/OrderBasisAdapter';

/**
 * 発注根拠情報を取得するUseCase
 */
export class GetOrderBasisUseCase {
  private repository: IOrderBasisRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderBasisRepository) {
    this.repository = repository;
  }

  /**
   * 発注根拠情報を取得する
   * @param orderBasisId - 発注根拠情報
   * @returns - IOrderBasis型の発注根拠情報
   */
  public execute = async (orderBasisId: string): Promise<INetworkResult<IOrderBasis, IError>> => {
    try {
      const result = await this.repository.get(orderBasisId);

      switch (result.status.type) {
        case 'success':
          const adaptedData = OrderBasisAdapter.adapt(result.status.data);
          return {
            status: {
              type: 'success',
              data: adaptedData,
            },
          };
        case 'error':
          return {
            status: {
              type: 'error',
              error: result.status.error,
            },
          };
        default:
          throw Error('想定外のエラー');
      }
    } catch (err) {
      console.error(err);
      return {
        status: {
          type: 'error',
          error: {
            statusCode: -1,
            code: 'unknown',
            message: '想定外のエラー',
          },
        },
      };
    }
  };
}
